/**
 * Model for the data to be displayed by {@link BooleanDialogComponent}.
 */
export interface BooleanDialogData {
  /**
   * Text for the button, which returns `false`
   */
  falseText?: string;

  /**
   * message to be displayed
   */
  message: string;

  /**
   * question to be displayed
   */
  question: string;

  /**
   * dialog title
   */
  title: string;

  /**
   * Text for the button, which returns `true`
   */
  trueText?: string;
}
